/**
 * E2E auth helpers — active only when REACT_APP_ENABLE_E2E_AUTH=true.
 * The `?e2e_token=` handling lives in contexts/auth/AuthProvider.tsx.
 */
import { env } from '../env';

export function isE2eAuthEnabled(): boolean {
  return env.ENABLE_E2E_AUTH === 'true';
}
